import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../../services/api";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import InputWrapDiv from "../../components/common/InputWrapDiv";
import TopBoxDiv from "../../components/common/TopBoxDiv";
import CodeSelectBox from "../../components/common/CodeSelectBox";
import ContentInput from "../../components/common/ContentInput";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import FunctionButton from "../../components/common/FunctionButton";
import MessageDialog from "../../components/common/MessageDialog";
import { useMenuAuthInfo, useMultiLang } from "../../services/GlobalUtil";
import { useTranslation } from "react-i18next";

const ItemCodeManagementEditPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const menuAuthInfo = useMenuAuthInfo();
  const { t } = useTranslation();

  const cMajorCode = location.state?.majorCode || null;
  const cMiddleCode = location.state?.middleCode || null;
  const cMinorCode = location.state?.minorCode || null;

  const [inspType, setInspType] = useState("");
  const [itemCode1, setItemCode1] = useState("");
  const [itemCode2, setItemCode2] = useState("");
  const [itemCode3, setItemCode3] = useState("");
  const [itemCode4, setItemCode4] = useState("");
  const [itemCode5, setItemCode5] = useState("");
  const [itemCode6, setItemCode6] = useState("");
  const [itemKor, setItemKor] = useState("");
  const [itemEng, setItemEng] = useState("");
  const [itemDescKor, setItemDescKor] = useState("");
  const [itemDescEng, setItemDescEng] = useState("");
  const [unit, setUnit] = useState();

  const sbInspType = [
    { code: "", codeDesc: t("L0126") },
    ...useMultiLang("INSPTYPE"),
  ];

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDialogOpen2, setIsDialogOpen2] = useState(false);

  useEffect(() => {
    loadContentData();
  }, []);

  const loadContentData = () => {
    if (cMajorCode !== null)
      api
        .post("/manage/itemcode/detail", {
          majorCode: cMajorCode,
          middleCode: cMiddleCode,
          minorCode: cMinorCode,
        })
        .then((response) => {
          setInspType(response.data.type);
          setItemCode1(response.data.majorCode.charAt(0));
          setItemCode2(response.data.majorCode.charAt(1));
          setItemCode3(response.data.majorCode.charAt(2));
          setItemCode4(response.data.majorCode.charAt(3));
          setItemCode5(response.data.middleCode);
          setItemCode6(response.data.minorCode);
          setItemKor(response.data.itemCodeKor);
          setItemEng(response.data.itemCodeEng);
          setItemDescKor(response.data.itemDescKor);
          setItemDescEng(response.data.itemDescEng);
          setUnit(response.data.unit);
        })
        .catch(() => {});
  };

  const handleInspTypeChange = (e) => {
    setInspType(e.target.value);
  };

  const handleItemCode1Change = (e) => {
    setItemCode1(e.target.value);
  };

  const handleItemCode2Change = (e) => {
    setItemCode2(e.target.value);
  };

  const handleItemCode3Change = (e) => {
    setItemCode3(e.target.value);
  };

  const handleItemCode4Change = (e) => {
    setItemCode4(e.target.value);
  };

  const handleItemCode5Change = (e) => {
    setItemCode5(e.target.value);
  };

  const handleItemCode6Change = (e) => {
    setItemCode6(e.target.value);
  };

  const handleItemKorChange = (e) => {
    setItemKor(e.target.value.trim());
  };

  const handleItemEngChange = (e) => {
    setItemEng(e.target.value.trim());
  };

  const handleItemDescKorChange = (e) => {
    setItemDescKor(e.target.value.trim());
  };

  const handleItemDescEngChange = (e) => {
    setItemDescEng(e.target.value.trim());
  };

  const handleUnitChange = (e) => {
    setUnit(e.target.value.trim());
  };

  const handleSubmit = () => {
    if (!validate()) {
      return;
    }
    if (cMajorCode === null || cMajorCode === "") {
      api
        .post("/manage/itemcode/add", {
          type: inspType,
          majorCode: itemCode1 + itemCode2 + itemCode3 + itemCode4,
          middleCode: itemCode5,
          minorCode: itemCode6,
          itemCodeKor: itemKor,
          itemCodeEng: itemEng,
          itemDescKor: itemDescKor,
          itemDescEng: itemDescEng,
          level: itemCode6 ? 3 : itemCode5 ? 2 : 1,
          unit: unit,
        })
        .then(() => {
          setIsDialogOpen(true);
        })
        .catch((error) => {
          if (error.response.data.result == "1") {
            setIsDialogOpen2(true);
          }
        });
    } else {
      api
        .post("/manage/itemcode/update", {
          majorCode: cMajorCode,
          middleCode: cMiddleCode,
          minorCode: cMinorCode,
          itemCodeKor: itemKor,
          itemCodeEng: itemEng,
          itemDescKor: itemDescKor,
          itemDescEng: itemDescEng,
          unit: unit,
        })
        .then(() => {
          setIsDialogOpen(true);
        })
        .catch(() => {});
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleConfirm = () => {
    setIsDialogOpen(false);
    navigate("/manage/itemcode");
  };

  const handleDupConfirm = () => {
    setIsDialogOpen2(false);
  };

  const [errors, setErrors] = useState({
    validInspType: "",
    validCode: "",
    validEng: "",
    validDescEng: "",
  });

  const validate = () => {
    let tempErrors = {};
    let isValid = true;

    if (!inspType) {
      tempErrors.validInspType = "Inspection Type is required.";
      isValid = false;
    }

    if (!itemCode1 || !itemCode2 || !itemCode3 || !itemCode4) {
      tempErrors.validCode = "Code is required.";
      isValid = false;
    }

    if (!itemEng) {
      tempErrors.validEng = "Item ENG is required.";
      isValid = false;
    }

    if (!itemDescEng) {
      tempErrors.validDescEng = "Item Description ENG is required.";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  return (
    <div>
      <BreadCrumbDiv
        items={[t("MENU:L0056"), t("MENU:L0086") + " Reg/Edit"]}
      ></BreadCrumbDiv>

      <InputWrapDiv>
        <TopBoxDiv value={t("MENU:L0086") + " Reg/Edit"}></TopBoxDiv>

        <table>
          <tbody>
            <tr>
              <th>
                {t("L0126")} *
                {errors.validInspType && (
                  <>
                    <br />
                    <span style={{ color: "red", fontSize: "10px" }}>
                      {errors.validInspType}
                    </span>
                  </>
                )}
              </th>
              <td>
                <CodeSelectBox
                  value={inspType}
                  codes={sbInspType}
                  onChange={handleInspTypeChange}
                  isCodeVisible={false}
                  multiple={false}
                  width="96%"
                  style={{
                    backgroundColor:
                      cMajorCode !== null ? "#f6f3f2" : undefined,
                    border: "1px solid #e4dcd3",
                  }}
                  disabled={cMajorCode !== null}
                />
              </td>
            </tr>
            <tr>
              <th>
                {t("MENU:L0086")} *
                {errors.validCode && (
                  <>
                    <br />
                    <span style={{ color: "red", fontSize: "10px" }}>
                      {errors.validCode}
                    </span>
                  </>
                )}
              </th>
              <td>
                <ContentInput
                  value={itemCode1}
                  disabled={cMajorCode !== null}
                  maxLength={1}
                  width={"55px"}
                  onChange={handleItemCode1Change}
                ></ContentInput>
                <ContentInput
                  value={itemCode2}
                  disabled={cMajorCode !== null}
                  maxLength={1}
                  width={"55px"}
                  onChange={handleItemCode2Change}
                ></ContentInput>
                <ContentInput
                  value={itemCode3}
                  disabled={cMajorCode !== null}
                  maxLength={1}
                  width={"55px"}
                  onChange={handleItemCode3Change}
                ></ContentInput>
                <ContentInput
                  value={itemCode4}
                  disabled={cMajorCode !== null}
                  maxLength={1}
                  width={"55px"}
                  onChange={handleItemCode4Change}
                ></ContentInput>
                <ContentInput
                  value={itemCode5}
                  disabled={cMajorCode !== null}
                  maxLength={1}
                  width={"55px"}
                  onChange={handleItemCode5Change}
                ></ContentInput>
                <ContentInput
                  value={itemCode6}
                  disabled={cMajorCode !== null}
                  maxLength={1}
                  width={"55px"}
                  onChange={handleItemCode6Change}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>{t("L0692") + " KOR"}</th>
              <td>
                <ContentInput
                  value={itemKor}
                  maxLength={125}
                  onChange={handleItemKorChange}
                  disabled={!menuAuthInfo.edit}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>
                {t("L0692") + " ENG *"}
                {errors.validEng && (
                  <>
                    <br />
                    <span style={{ color: "red", fontSize: "10px" }}>
                      {errors.validEng}
                    </span>
                  </>
                )}
              </th>
              <td>
                <ContentInput
                  value={itemEng}
                  maxLength={125}
                  onChange={handleItemEngChange}
                  disabled={!menuAuthInfo.edit}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th> {t("L0692") + " " + t("L0143") + " KOR"}</th>
              <td>
                <ContentInput
                  value={itemDescKor}
                  maxLength={2000}
                  onChange={handleItemDescKorChange}
                  disabled={!menuAuthInfo.edit}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>
                {t("L0692") + " " + t("L0143") + " ENG *"}
                {errors.validDescEng && (
                  <>
                    <br />
                    <span style={{ color: "red", fontSize: "10px" }}>
                      {errors.validDescEng}
                    </span>
                  </>
                )}
              </th>
              <td>
                <ContentInput
                  value={itemDescEng}
                  maxLength={2000}
                  onChange={handleItemDescEngChange}
                  disabled={!menuAuthInfo.edit}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>{t("L1021")}</th>
              <td>
                <ContentInput
                  value={unit}
                  maxLength={8}
                  onChange={handleUnitChange}
                  disabled={!menuAuthInfo.edit}
                ></ContentInput>
              </td>
            </tr>
          </tbody>
        </table>
      </InputWrapDiv>

      <ButtonWrapDiv className="btn_bottom">
        {menuAuthInfo.edit && (
          <FunctionButton
            className="big"
            value={t("L0659")}
            onClick={handleSubmit}
          ></FunctionButton>
        )}
        <FunctionButton
          className="big bg_gray"
          value={t("L0005")}
          onClick={handleCancel}
        ></FunctionButton>
      </ButtonWrapDiv>

      {isDialogOpen && (
        <MessageDialog title={t("L0339")} message={t("L0103")}>
          <FunctionButton
            value={t("L0004")}
            onClick={handleConfirm}
          ></FunctionButton>
        </MessageDialog>
      )}

      {isDialogOpen2 && (
        <MessageDialog title={t("L0339")} message={t("L0124")}>
          <FunctionButton
            value={t("L0004")}
            onClick={handleDupConfirm}
          ></FunctionButton>
        </MessageDialog>
      )}
    </div>
  );
};
export default ItemCodeManagementEditPage;
